import { createVanIconComponent } from "./van"

const CartCircle = createVanIconComponent("cart-circle")
export default CartCircle
